// extracted by mini-css-extract-plugin
module.exports = {"select-button":"select_select-button__KhbHn","select-button_opened":"select_select-button_opened__2DWCk"};